import { getAuthUrl } from '../../utils/base-url';
import { HttpServiceConfigurator } from './http-service-configurator';

export class AuthHttpServiceConfigurator extends HttpServiceConfigurator {

  getHttpClientConfig() {
    const baseConfig = super.getHttpClientConfig();
    return {
      ...baseConfig,
      baseURL: getAuthUrl(),
    };
  }
}
